import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import cx from 'classnames';
import { isValidUrl } from '~/Share/Utils';
import { LinkRequestType } from '~/types/models/testimonial';
import { socialIcons } from '../../../Pages/Editor/constants';
import { SocialType } from '@vimily/bonjoro-ui-components-v2';
import { socials } from '~/App/Modules/Socials/util';

export function getLinkIconUrl(linkRequestType: LinkRequestType) {
  switch (linkRequestType) {
    case LinkRequestType.Twitter:
      return socials[SocialType.Twitter].iconUrl;
    case LinkRequestType.Website:
    case LinkRequestType.CustomLink:
      return socialIcons[LinkRequestType.Website];
    default:
      return socialIcons[linkRequestType];
  }
}

interface RequestLinkIconProps {
  linkRequestType: LinkRequestType;
}

function RequestLinkIcon({ linkRequestType }: RequestLinkIconProps) {
  const linkIconUrl = getLinkIconUrl(linkRequestType);
  return <img src={linkIconUrl} className='rounded h-5 w-5 mr-2' />;
}

export interface ResponseLabelProps {
  linkRequestType?: LinkRequestType;
  title?: string;
  content: React.ReactNode;
  className?: string;
}

export default function ResponseLabel({
  linkRequestType,
  title,
  content,
  className,
}: ResponseLabelProps) {
  return (
    <span className={cx('items-start truncate', className)}>
      {title && <span className='font-semibold mr-1'>{title}:</span>}
      {linkRequestType ? (
        <span className='flex space-x-2.5 items-center'>
          <RequestLinkIcon linkRequestType={linkRequestType} />
          <span className='truncate'>{content}</span>
          {isValidUrl(content as string) && (
            <a href={content as string} target='_blank' rel='noreferrer'>
              <FontAwesomeIcon
                icon={faArrowUpRightFromSquare}
                className='text-sm text-neutral-600'
              />
            </a>
          )}
        </span>
      ) : (
        content
      )}
    </span>
  );
}
